<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>应用迁移</span>
        <span style="color:red;font-size:14px;margin-left:40px;">应用迁移（更换商户/主体）请联系平台商务协助</span>
      </div>

      <el-form :inline="true" :model="formSearch" class="demo-form-inline" size="mini">
        <el-form-item label="应用名称">
          <el-input v-model="formSearch.applyName" placeholder="应用名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPage">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" style="width: 100%" size="mini">
        <el-table-column prop="applyNo" label="应用编号" width="120"/>
        <el-table-column prop="applyName" label="应用名称" width="140"/>
        <el-table-column prop="merchNo" label="商户编号" width="120"/>
        <el-table-column prop="merchName" label="商户名称"/>
        <el-table-column prop="takeDate" label="生效日期" :formatter="formatDate" width="140"/>
        <el-table-column prop="newMerchNo" label="迁入商户号" width="100"/>
        <el-table-column prop="newMerchName" label="迁入商户名称"/>
        <el-table-column prop="takeState" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.takeState == '1'" type="success" disable-transitions>已迁移</el-tag>
            <el-tag v-if="scope.row.takeState == '0'" type="primary" disable-transitions>未生效</el-tag>
            <el-tag v-if="scope.row.takeState == '2'" type="primary" disable-transitions>已撤销</el-tag>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="float:right;margin:10px" @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageresult.pageSize"
        layout="total, prev, pager, next"
        :total="pageresult.totalSize">
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      ruleForm: {
        applyno:''
      },
      rules:{
        applyno: [
          { required: true, message: '请输入应用编号', trigger: 'blur' }
        ]
      },
      ruleAddForm: {
        applyNo:''
      },
      rulesAdd:{
        merchNo: [
          { required: true, message: '请输入商户编号', trigger: 'blur' }
        ]
      },
      apply:{},//应用信息
      merch:{},//商户信息
      drawer: false,
      formSearch: {
        applyName: '',
        pageNum:1
      },
      pageresult:{},
      tableData:[]
    }
  },
  created(){
    this.getPage();
  },
  methods: {
    handleCurrentChange(val) {
      this.formSearch.pageNum = val;
      this.getPage();
    },
    formatDate(row, column) {
      return moment(row.takeDate).format("YYYY-MM-DD HH");
    },
    getPage(){
      let _this = this;
      let info = this.$store.state.userInfo;
      console.log(info)
      _this.formSearch.merchNo = info.userbh;
      this.$ajax({
        url:"coupon-merch/applyTransfer/get/merch/transfer",
        async:false,
        data:_this.formSearch,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            _this.tableData=response.data.content;
            _this.pageresult = response.data;
          }else{
            _this.$message.error(response.message);
          }
        }
      })
    }
  }
}
</script>

<style>
.tpc .el-time-spinner__wrapper {
  width:100% !important;
}
.tpc .el-scrollbar:nth-of-type(2) {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/merch/merchTransfer.vue